import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import { backGroundColorCode } from "../../../commons/colors";

export default function DialogButton(props) {
  const user = useRecoilValue(userState);
  const getStyles = (colorStyle) => {
    let styles = {
      backgroundColor: "#1E90FF",
      color: "#000",
      fontSize: 16,
      height: 32,
      padding: 0,
      // marginBottom: 16,
      width: 96,
      "&:hover": {
        color: "#F0F2F5",
        backgroundColor: "#00008B",
      },
    };
    switch (colorStyle) {
      case "yesColor":
        styles.backgroundColor = "#1E90FF";
        styles.color = "#000";
        styles["&:hover"].backgroundColor = "#00008B";
        styles["&:hover"].color = "#F0F2F5";
        break;
      case "noColor":
        styles.backgroundColor = backGroundColorCode(user?.mode ?? "lite");
        styles.color = "primary.main";
        styles["&:hover"].backgroundColor = "#ff0";
        styles["&:hover"].color = "primary.main";
        break;
      default:
        break;
    }
    return styles;
  };
  return (
    <Button
      component="label"
      variant="contained"
      disabled={props.disabled}
      onClick={() => props.onClick()}
      sx={getStyles(props.colorStyle)}
    >
      {props.label}
      {/* <VisuallyHiddenInput type="file" /> */}
    </Button>
  );
}
